import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	errorFieldEmptyName: {
		id: 'project-settings-apps.issue-type-page.fields.field.error-field-empty-name',
		defaultMessage: 'Give the field a name',
		description: 'Displayed when creating new field and leaving the name box empty',
	},
	errorFieldDescriptionTooLong: {
		id: 'project-settings-apps.issue-type-page.fields.field.error-field-description-too-long',
		defaultMessage: "Description can't exceed {maxCharacters} characters",
		description:
			'Error message to show when a field description exceeds the maximum allowed number of characters',
	},
});
